<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="4">
          <AutocompleteSchoolYear :defaultYear="defaultYear.id" @change="change" />
        </v-col>
        <v-col cols="4"> </v-col>
        <v-col cols="4"> </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { get } from 'lodash'

import AutocompleteSchoolYear from '../../components/basic/input/AutocompleteSchoolYear.vue'

export default {
  components: { AutocompleteSchoolYear },
  data() {
    return {
      defaultYear: {},
      schoolYear: null,
      present: null,
      time: moment().toISOString(),
    }
  },
  computed: {
    ...mapState('app', ['currentSchoolYear']),
  },
  mounted() {
    if (get(this.currentSchoolYear, 'id')) {
      this.defaultYear = this.currentSchoolYear
      this.schoolYear = get(this.currentSchoolYear, 'id', null)
      this.$emit('onFilterChanged', { schoolYear: this.currentSchoolYear.id })
    }
  },
  methods: {
    onFilterChanged() {
      const params = {
        schoolYear: this.schoolYear,
      }

      this.$emit('onFilterChanged', params)
    },
    change(data) {
      this.schoolYear = data
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
